import { get, post } from '@/utils/request'

export function getOrderList(params) {
  return get('/order/list', params)
}

export function getOrderDetail(id) {
  return get(`/order/detail/${id}`)
}

export function createOrder(data) {
  return post('/order/create', data)
}

export function cancelOrder(id) {
  return post(`/order/cancel/${id}`)
}
